import { useEffect, useState } from 'react'
import apiClient from '../services/api'

export const defaultSiteSettings = {
  siteName: 'Harmony Medical Clinic',
  siteTagline: 'Delivering compassionate consultations, preventive care, diagnostics, and family-focused medical support.',
  contactPhone: '(555) 678-9101',
  contactEmail: 'info@harmonymedclinic.com',
  contactAddress: '123 Health Blvd, Springfield, IL 62704',
  contactHoursWeekdays: 'Mon - Fri: 8:00 AM to 7:00 PM',
  contactHoursSaturday: 'Saturday: 9:00 AM to 3:00 PM',
  contactHoursSunday: 'Sunday: Emergency support only',
  facebookUrl: 'https://facebook.com',
  instagramUrl: 'https://instagram.com',
  twitterUrl: 'https://twitter.com'
}

const mapSettingsArray = (items = []) =>
  items.reduce((acc, item) => {
    acc[item.name] = item.value
    return acc
  }, {})

const useSiteSettings = () => {
  const [settings, setSettings] = useState(defaultSiteSettings)

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const response = await apiClient.get('/api/cms/public-settings')
        setSettings((prev) => ({ ...prev, ...mapSettingsArray(response.data) }))
      } catch (error) {
        console.error('Error loading public site settings:', error)
      }
    }

    loadSettings()
  }, [])

  return settings
}

export default useSiteSettings
